export default __webpack_public_path__ + "static/media/statistics.9dd0bd47.svg";